module.exports = __webpack_public_path__ + "img/government-right-1.a0358241.png";